/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import wcClient from 'wc-api';

const RESOURCE_PAGE = "guesttoken";

export const getGuestToken = function(wcEnv, data){
    if(!wcEnv){
        wcEnv = {
            rootUri: "/session/"
        };
    }

    if (!wcEnv.rootUri)
    {
        wcEnv.rootUri = "/session/";
    }

    return wcClient.wcPost(wcEnv, RESOURCE_PAGE, null, data).then(response => { 
        return response;
    });
};